import DefaultImageSVG from '@plone/volto/components/manage/Blocks/Listing/default-image.svg';
import { Image } from '@arpav/components/ArpavTheme';

const ListingImage = ({
  item,
  showDefault = false,
  useOriginal = false,
  maxSize,
  className = 'listing-image',
  ...imageProps
}) => {
  if (!item.image_field) {
    if (showDefault) {
      return <img src={DefaultImageSVG} alt="" />;
    }
    return null;
  } else {
    return (
      <Image
        className={className}
        image={item['@id']}
        aria-hidden="true"
        alt={item.title}
        title={item.title}
        role="presentation"
        imageField={item.image_field}
        useOriginal={useOriginal}
        maxSize={maxSize}
        {...imageProps}
      />
    );
  }
};

export default ListingImage;
